// extracted by mini-css-extract-plugin
export var container = "_55-0";
export var disabled = "_55-4";
export var fullWidth = "_55-3";
export var lined = "_55-1";
export var selected = "_55-5";
export var tab = "_55-2";